export const formatNumber = (value: number | null) => {
  if (value === null) {
    return value;
  }
  const formatter = new Intl.NumberFormat("ja-JP");
  return formatter.format(value);
};

export const formatCurrency = (value: number | null) =>
  `¥ ${formatNumber(value)}`;
